import { render, staticRenderFns } from "./KChallengeUpdateForm.vue?vue&type=template&id=cad06df0&"
import script from "./KChallengeUpdateForm.vue?vue&type=script&lang=js&"
export * from "./KChallengeUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./KChallengeUpdateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports